import React, { useState } from 'react';
import Layout from '../components/Layout';
import { FaSatelliteDish, FaPaperPlane } from 'react-icons/fa';

const Contacts = () => {
  const [status, setStatus] = useState('IDLE'); // IDLE, SENDING, SENT, ERROR
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const encode = (data) => {
    return Object.keys(data)
        .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
        .join("&");
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus('SENDING');

    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode({ "form-name": "contact", ...formData })
    })
      .then(() => {
        setStatus('SENT');
        setFormData({ name: '', email: '', message: '' });
        setTimeout(() => setStatus('IDLE'), 3000);
      })
      .catch(error => {
        console.error("Form submission error:", error);
        setStatus('ERROR');
        setTimeout(() => setStatus('IDLE'), 3000);
      });
  };

  return (
    <Layout>
      <div className="max-w-2xl mx-auto">
        <div className="bg-slate-900 border-2 border-slate-700 rounded-lg p-1 shadow-[0_0_20px_rgba(0,0,0,0.5)]">
          {/* Terminal Header */}
          <div className="bg-slate-800 px-4 py-2 flex items-center justify-between border-b border-slate-700">
            <div className="flex items-center gap-2 text-green-500 font-mono text-sm">
              <div className="w-3 h-3 rounded-full bg-green-500 animate-pulse"></div>
              COMMS_UPLINK_ESTABLISHED
            </div>
            <FaSatelliteDish className="text-slate-500" />
          </div>

          {/* Terminal Body */}
          <div className="p-8">
            <h2 className="text-3xl font-bold text-white mb-6 font-mono">
              <span className="text-cyan-500">&gt;</span> Send Transmission
            </h2>

            <form onSubmit={handleSubmit} className="space-y-6">
              <input type="hidden" name="form-name" value="contact" />
              <div>
                <label className="block text-cyan-400 font-mono text-sm mb-2">
                  ENTER_IDENTITY
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full bg-slate-800 border border-slate-600 text-white p-3 rounded focus:outline-none focus:border-cyan-500 focus:ring-1 focus:ring-cyan-500 font-mono transition-all"
                  placeholder="Agent Name"
                />
              </div>
              
              <div>
                <label className="block text-cyan-400 font-mono text-sm mb-2">
                ENTER_FREQUENCY (EMAIL)
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full bg-slate-800 border border-slate-600 text-white p-3 rounded focus:outline-none focus:border-cyan-500 focus:ring-1 focus:ring-cyan-500 font-mono transition-all"
                  placeholder="agent@example.com"
                />
              </div>

              <div>
                <label className="block text-cyan-400 font-mono text-sm mb-2">
                ENCRYPTED_MESSAGE
                </label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="4"
                  required
                  className="w-full bg-slate-800 border border-slate-600 text-white p-3 rounded focus:outline-none focus:border-cyan-500 focus:ring-1 focus:ring-cyan-500 font-mono transition-all"
                  placeholder="Type your message here..."
                ></textarea>
              </div>

              <button
                type="submit"
                disabled={status === 'SENDING' || status === 'SENT'}
                className={`w-full py-4 rounded font-bold font-mono flex items-center justify-center gap-2 transition-all duration-300 active:scale-95 ${
                  status === 'SENT' 
                    ? 'bg-green-600 text-white' 
                    : status === 'ERROR'
                    ? 'bg-red-600 text-white'
                    : 'bg-cyan-600 hover:bg-cyan-500 text-white hover:shadow-[0_0_15px_rgba(6,182,212,0.5)]'
                }`}
              >
                {status === 'IDLE' && <><FaPaperPlane /> TRANSMIT_DATA</>}
                {status === 'SENDING' && 'UPLOADING...'}
                {status === 'SENT' && 'TRANSMISSION_COMPLETE'}
                {status === 'ERROR' && 'TRANSMISSION_FAILED'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Contacts;
